/* eslint-disable */
// <defs><style>.cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}.cls-16{fill:url(#linear-gradient-16);}.cls-17{fill:url(#linear-gradient-17);}.cls-18{fill:url(#linear-gradient-18);}.cls-19{fill:url(#linear-gradient-19);}.cls-20{fill:url(#linear-gradient-20);}.cls-21{fill:url(#linear-gradient-21);}.cls-22{fill:url(#linear-gradient-22);}</style>
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';
export const SvgLocationPin = ({ size }) => {
    return (
        <Svg width={size} height={size} viewBox="0 0 29 34" version="1.1" >
            <G id="AFTER?-Copy-6" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-18.000000, -135.000000)" strokeLinecap="round" strokeLinejoin="round">
                <G id="Group-3-Copy" transform="translate(20.000000, 137.000000)" stroke="#1A1A1A" strokeWidth="3">
                    <G id="map-pin">
                        <Path d="M24.6,12.2727272 C24.6,21.8181818 12.3,30 12.3,30 C12.3,30 0,21.8181818 0,12.2727272 C1.01225114e-07,5.49468708 5.50689765,-3.02788099e-16 12.3,0 C19.0931024,3.02788099e-16 24.5999999,5.49468708 24.6,12.2727272 Z" id="Shape"></Path>
                        <Circle id="Oval" cx="12.6" cy="12.6" r="4.2"></Circle>
                    </G>
                </G>
            </G>
        </Svg>
    )
}

